module.exports = __webpack_public_path__ + "./fonts/new_logo.bb3fff6a7dd61714df56224fd4cce833.svg";